import React from 'react';

export default function CustomTabLabel({ index, selectedTab, setSelectedTab, title, palette }) {
    return (
        <div
            className={`py-2 px-4 rounded-t-lg transition-colors duration-200 ${selectedTab === index ? '' : 'cursor-pointer'}`}
            style={selectedTab === index ? {
                background: palette.primaryBg || 'rgba(88, 129, 87, 0.314)',
                color: palette.primaryText || '#31502d',
                fontWeight: 600
            } : {}}
            onClick={() => setSelectedTab(index)}
        >
            {title.toUpperCase()}
        </div>
    );
}
